import { Component, Host, h, Prop, Watch, State, Listen } from '@stencil/core';
import { isMagnoliaEditingMode } from '../../helper';

interface UiCmsSpacingBody {
  space: number;
}

interface CssProperties {
  [key: string]: string;
}

@Component({
  tag: 'ui-cms-spacing',
  styleUrls: {
    default: 'ui-cms-spacing.scss',
    editing: 'ui-cms-spacing.magnolia.scss',
  },
  shadow: true,
})
export class UiCmsSpacing {
  @Prop({ mutable: true }) body: UiCmsSpacingBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @State() mobile = this.isMobile;

  private space: number;

  private componentStyle: CssProperties;

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
    this.componentStyle = this.generateComponentStyle(this.body.space);
  }

  @Listen('resize', { target: 'window' })
  onWindowResize() {
    this.mobile = this.isMobile;
  }

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
  }

  private get isMobile(): boolean {
    return window.innerWidth < 992;
  }

  private generateComponentStyle(selectedSpace: number): any {
    const space = this.mobile && selectedSpace > 16 ? 16 : selectedSpace;

    this.space = space;

    if (!selectedSpace || isMagnoliaEditingMode()) {
      return {};
    }

    const cssPropertyName = space > 0 ? 'height' : 'marginTop';

    return {
      [cssPropertyName]: `${space}px`,
    };
  }

  render() {
    return (
      <Host style={this.componentStyle} class={{ 'positive-value': this.space > 0, 'negative-value': this.space < 0 }}>
        {isMagnoliaEditingMode() && (
          <span>
            <b>{this.space}px</b>
          </span>
        )}
      </Host>
    );
  }
}
